import { BaseTool } from '../BaseTool';

export class DesignOptionsTool extends BaseTool {
    id = 'MANAGE_DESIGN_OPTIONS';
    name = 'Design Options';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('designOptions');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
